import { randomNumber } from '@/helpers/helpers';
import adSlotInfo from '@/data/adSlotInfo.json'

const adSenseBrands = ['windalert', 'fishweather']

function setAdSource(brand) {
  let source = adSenseBrands.indexOf(brand.toLowerCase()) > -1 ? 'adsense' : 'gpt'

  if (brand.toLowerCase() === 'windalert') {
    if (randomNumber(1, 100) <= 50) {
      source = 'gpt'
    }
  }

  return source
}

function getPrimaryActivity(brand) {
  const randomNum = randomNumber(1, 100)
  let pa = null

  if (brand.toLowerCase() === 'windalert') {
    if (randomNum >= 1 && randomNum <= 10) {
      pa = 'Wind'
    } else if (randomNum >= 11 && randomNum <= 40) {
      pa = 'Sail'
    } else {
      pa = 'Kite'
    }
  } else if (brand.toLowerCase() === 'ikitesurf') {
    if (randomNum === 1) {
      pa = 'Sail'
    } else {
      pa = 'Kite'
    }
  } else if (brand.toLowerCase() === 'iwindsurf') {
    if (randomNum <= 70) {
      pa = 'Wind'
    } else {
      pa = 'Kite'
    }
  } else if (brand.toLowerCase() === 'sailflow') {
    if (randomNum === 1) {
      pa = 'Wind'
    } else if (randomNum >= 2 && randomNum <= 20) {
      pa = 'Kite'
    } else {
      pa = 'Sail'
    }
  }

  return pa
}

export default (parameters) => {
  const { brand } = parameters

  const primaryActivities = {
    sailflow: getPrimaryActivity('sailflow'),
    fishweather: 'Fish',
    iwindsurf: getPrimaryActivity('iwindsurf'),
    ikitesurf: getPrimaryActivity('ikitesurf'),
    windalert: getPrimaryActivity('windalert'),
    other: 'Wind',
    both: 'Wind'
  }

  let adSource = setAdSource(brand)

  return {
    ads_allowed: false,
    gpt_primary_activity: primaryActivities[brand.toLowerCase()],
    ad_source: adSource,
    ad_slot_info: adSlotInfo,
    footer_ad: false
  }
}
